<template>
<el-popover
  placement="bottom"
  trigger="click"
>
  <template>
    <section class="tree-popover-wrapper">
      <div class="tree-popover-select-list">
        <el-tree
          ref="factor-tree"
          :data="factorTree"
          :props="{
          value: 'id',
          label: 'name'
        }"
          node-key="id"
          show-checkbox
          accordion
          @check="onFactorCheckChange"
        />
      </div>

      <select-ctrl-group
        :ids="query.factorIds"
        :options="leafFactors"
        style="padding-bottom:0;"
        @change="onSelectCtrlChange"
      />
    </section>
  </template>
  <template #reference>
    <el-button :disabled="disabled" size="small">{{title}}</el-button>
  </template>
</el-popover>
</template>

<script>
import SelectCtrlGroup from '../../SelectCtrlGroup/index'
export default {
  name: 'FactorTreeQuery',
  components: {SelectCtrlGroup},
  props: {
    factorTree: {
      required: true,
      type: Array
    },
    query: {
      required: true,
      type: Object
    },
    title: {
      default: '选择因子'
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    leafFactors () {
      const tmpList = [...this.factorTree]
      const leafFactors = []

      for (let i = 0; i < tmpList.length; i++) {
        const factor = tmpList[i]
        const {children} = factor

        if (Array.isArray(children) && children.length > 0) {
          tmpList.splice(i + 1, 0, ...children)
        } else {
          leafFactors.push(factor)
        }
      }

      return leafFactors
    }
  },
  methods: {
    onFactorCheckChange () {
      let checkedFactorList = this.getFactorTree().getCheckedNodes()
      this.query.factorIds = checkedFactorList.filter(item => !Array.isArray(item.children)).map(item => item.id)
    },
    setCheckedKeys (factorIds) {
      let factorTree = this.getFactorTree()

      if (factorTree) {
        factorTree.setCheckedKeys(factorIds)
      }
    },
    getFactorTree () {
      return this.$refs['factor-tree']
    },
    onSelectCtrlChange (ids) {
      this.setCheckedKeys(ids)
    }
  }
}
</script>

<style lang="scss" scoped>
.tree-popover-wrapper {
  display: grid;
  grid-template-rows: minmax(calc(100% - 33px), auto) max-content;
  max-height: 300px;

  .tree-popover-select-list {
    min: {
      width: 0;
      height: 0;
    };
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/Query/FactorTreeQuery.vue